import { render } from "./MPCGPU.vue?vue&type=template&id=f76ff6f0&scoped=true&ts=true"
import script from "./MPCGPU.vue?vue&type=script&lang=ts"
export * from "./MPCGPU.vue?vue&type=script&lang=ts"

import "./MPCGPU.vue?vue&type=style&index=0&id=f76ff6f0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f76ff6f0"]])

export default __exports__